module.exports = __webpack_public_path__ + "img/unicredit-italic.0aa4f2a6.svg";